import type {
    MarkdownKeys
} from "./type";

export const DEFAULT_VARIANTS: Record<MarkdownKeys, keyof NCoreUIKit.Typography> = {
    "##### ": "headlineMediumSize",
    "###### ": "headlineSmallSize",
    "#### ": "headlineLargeSize",
    "## ": "displayMediumSize",
    "### ": "displaySmallSize",
    "<br/>": "bodyMediumSize",
    "# ": "displayLargeSize",
    "```": "labelMediumSize",
    "<<": "titleMediumSize",
    "<p>": "bodyMediumSize",
    "- ": "bodyLargeSize",
    "* ": "bodyLargeSize",
    "": "bodyLargeSize"
};
